import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import CustomerAddLayer from "./CustomerAddLayer";

const CustomerAddPage = () => {
  return (
    <>
      <MasterLayout>
        <Breadcrumb title="Add New Customer" />
        <CustomerAddLayer />
      </MasterLayout>
    </>
  );
};

export default CustomerAddPage;
